import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface Feature {
  title: string;
  description: string;
  iconKey?: string;
}

export interface FeatureGridProps {
  title?: string;
  features: Feature[];
}

export function FeatureGrid({ title, features }: FeatureGridProps) {
  return (
    <section className="bg-white py-16">
      <Container>
        {title ? <h2 className="mb-10 text-3xl font-bold tracking-tightish">{title}</h2> : null}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <article key={feature.title} className="rounded-xl border border-stone-200 p-6 shadow-soft">
              <h3 className="text-lg font-semibold text-stone-900">{feature.title}</h3>
              <p className="mt-2 text-sm text-stone-600">{feature.description}</p>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}

export const FeatureGridConfig: ComponentConfig<FeatureGridProps> = {
  fields: {
    title: { type: 'text' },
    features: {
      type: 'array',
      arrayFields: {
        title: { type: 'text' },
        description: { type: 'textarea' },
        iconKey: { type: 'text' },
      },
      defaultItemProps: { title: '', description: '' },
    },
  },
  defaultProps: { title: 'Pourquoi nous', features: [] },
  render: FeatureGrid,
};
